
import { doc, updateDoc, increment, getDoc } from 'firebase/firestore';
import { db } from './firebaseService';
import { CLEANUP_BADGES } from '../constants';
import { Badge } from '../types';

export interface CleanupResult {
  newCleanupCount: number;
  newBadge: Badge | null;
}

export async function logCleanup(
  spotId: string,
  userId: string,
): Promise<CleanupResult> {
  const now = Date.now();

  await updateDoc(doc(db, 'cached_spots', spotId), {
    lastCleanedUp: now,
    cleanupCount: increment(1),
  });

  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, { cleanupCount: increment(1) });

  const snap = await getDoc(userRef);
  const newCleanupCount: number = (snap.data()?.cleanupCount as number) || 1;

  const prev = newCleanupCount - 1;
  const newBadge = CLEANUP_BADGES.find(
    b => b.threshold <= newCleanupCount && b.threshold > prev
  ) ?? null;

  return { newCleanupCount, newBadge };
}

export function formatCleanupAge(ts: number): string {
  const diffMs = Date.now() - ts;
  const diffH = Math.floor(diffMs / (1000 * 60 * 60));
  if (diffH < 1) return 'Nettopp';
  if (diffH < 24) return `${diffH}t siden`;
  const diffD = Math.floor(diffH / 24);
  if (diffD === 1) return 'i går';
  return `${diffD} dager siden`;
}
